import React, { Component } from 'react';
import {
  // BrowserRouter as Router,
  Link
} from 'react-router-dom';
import SignOutForm from './SignOutForm.js';
//import "./basicforms.css";
import "./BeangoNavbar.css";


class BeangoNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responsiveOn: false
    }


    this.toggleResponsive = this.toggleResponsive.bind(this);
  }

  toggleResponsive() {
    this.setState({
      responsiveOn: !this.state.responsiveOn
    });
  }

  render(){
    // Responsive calss var. Uncomment when trying responsive again
    // const responsiveClass = this.state.responsiveOn ? "responsive" : "";
    return (

      <nav>
        <ul>
          <li className="fontlogo nav-item-left"><Link to="/">terra alta</Link></li>
    			<li className="fontnav">
    				{ !this.props.authData && <Link to="/signup">
  				   <input type="button" value="Sign Up"/>
  				</Link>}
  			  </li>

      		<li className="fontnav">
    				{ !this.props.authData && <Link to="/signin">Log In</Link>}
    			</li>


			  <li className="fontnav">
  				{this.props.authData &&
            <SignOutForm
              auth={this.props.auth}
              name="Sign Out"
              handleSignOut={this.props.handleAuthStateChange}
            />
          }
			  </li>


			 <li className="dropdown fontnav">
					{this.props.authData && <a className="dropbtn">Minha conta</a>}
					<div className="dropdown-content">
                        <Link to="/info">Cadastro</Link>
                        <Link to="/myorderspage">Pedidos</Link>
					</div>

        </li>
  			{this.props.authData &&
    			<li className="fontnav" ><Link to="/samplecartpage" className="dropbtn material-icons"> shopping_cart</Link></li>
        }

          <li className="fontnav" ><Link to="/offeringspage" className="dropbtn">Cafés</Link></li>



    		</ul>
      </nav>

    );
  }
}

export default BeangoNavbar;



// WEBPACK FOOTER //
// ./src/components/BeangoNavbar.js